import React, { useState, useRef, useEffect } from 'react';
import { useClickAway } from 'react-use';
import { DateRange } from 'react-date-range';

import styles from './index.module.css';
import '../date_range/styles.css';
import '../date_range/default.css';

const CompletDateRangePicker = ({
  setStartDate,
  setEndDate,
  startDate,
  endDate,
  isScrolling,
  style,
  className = 'col-lg-5',
  onClear,
}) => {
  const [showDateRange, setShowDateRange] = useState(false);
  const [focusedRange, setFocusedRange] = useState('start');
  const [range, setRange] = useState({
    startDate: startDate || new Date(),
    endDate: endDate || startDate || new Date(),
    key: 'selection',
  });

  const ref = useRef(null);

  const toggleDropdown = () => {
    setShowDateRange(!showDateRange);
  };

  const handleSelect = (ranges) => {
    setRange(ranges.selection);
    if (focusedRange === 'start') {
      setStartDate(ranges.selection.startDate);
      setEndDate(null);
      setFocusedRange('end');
    }
    if (focusedRange === 'end') {
      setEndDate(ranges.selection.endDate);
      setFocusedRange('start');
    }
  };

  const clearDates = (event) => {
    event.stopPropagation();
    setStartDate(null);
    setEndDate(null);
    setRange({
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    });
    setFocusedRange('start');
    setShowDateRange(false);
    if (onClear) {
      onClear();
    }
  };

  useClickAway(ref, () => {
    setShowDateRange(false);
  });

  useEffect(() => {
    if (showDateRange && isScrolling) {
      setShowDateRange(false);
    }
  }, [isScrolling, showDateRange]);

  return (
    <div className={className} style={style}>
      <div ref={ref} className={`${styles.wrapper} ${showDateRange ? styles.wrapper_open : ''}`}>
        <button type='button' className={`content_container ${styles.trigger}`} onClick={toggleDropdown}>
          <div className='row'>
            <img
              alt='date range'
              style={{ paddingLeft: '10px' }}
              src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/icons/calendar.svg'
            />
            {startDate === null && endDate === null ? (
              <p className='col-10'>Select a date range</p>
            ) : (
              <p className='col-10'>{`${startDate && startDate.getMonth() + 1 + '/' + startDate.getDate() + '/' + startDate.getFullYear()} - ${endDate && endDate.getMonth() + 1 + '/' + endDate.getDate() + '/' + endDate.getFullYear()}`}</p>
            )}
            <svg
              className={`marg-top-10 ${showDateRange ? styles.arrow_active_flipped : styles.arrow_active}`}
              width='15'
              height='10'
              viewBox='0 0 15 10'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path d='M1 1L7.27586 8L14 1' stroke='#59B6BE' strokeWidth='1.5' strokeLinecap='round' />
            </svg>
          </div>
        </button>
        {showDateRange && (
          <div className={styles.dropdown}>
            <DateRange
              ranges={[range]}
              onChange={handleSelect}
              rangeColors={['#59B6BE']}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              direction='horizontal'
              shownDate={range.startDate || new Date()}
              maxDate={new Date()}
            />
            <div className={styles.dropdown_footer}>
              <button type='button' className={styles.clear_btn} onClick={clearDates}>
                Clear dates
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompletDateRangePicker;
